import { Country } from "./types/countries.interface";

export const countries: Country[] = [
  {
    country: "Argentina",
    roles: ["Ar_Viewer", "Ar_Admin", "Ar_SuperAdmin"],
  },
  {
    country: "Belgium",
    roles: ["Be_Viewer", "Be_Admin", "Be_SuperAdmin"],
  },
  {
    country: "Colombia",
    roles: ["Co_Viewer", "Co_Admin", "Co_SuperAdmin"],
  },
  {
    country: "France",
    roles: ["Fr_Viewer", "Fr_Admin", "Fr_SuperAdmin"],
  },
  {
    country: "Germany",
    roles: ["Ge_Viewer", "Ge_Admin", "Ge_SuperAdmin"],
  },
  { country: "India", roles: ["In_Viewer", "In_Admin", "In_SuperAdmin"] },
  {
    country: "Luxembourg",
    roles: ["Lu_Viewer", "Lu_Admin", "Lu_SuperAdmin"],
  },
  {
    country: "Netherlands",
    roles: ["NL_Viewer", "NL_Admin", "NL_SuperAdmin"],
  },
  {
    country: "Singapore",
    roles: ["Sg_Viewer", "Sg_Admin", "Sg_SuperAdmin"],
  },
  {
    country: "Switzerland",
    roles: ["Ch_Viewer", "Ch_Admin", "Ch_SuperAdmin"],
  },
  { country: "UAE", roles: ["UAE_Viewer", "UAE_Admin", "UAE_SuperAdmin"] },
  {
    country: "USA",
    roles: [
      "USA_Viewer",
      "USA_Admin",
      "USA_Cluster1",
      "USA_Cluster2",
      "USA_Cluster3",
      "USA_Cluster4",
      "USA_Cluster5",
      "USA_SuperAdmin",
    ],
  },
  {
    country: "all",
    roles: ["Gr_SuperAdmin"],
  },
];
